module.exports = __webpack_public_path__ + "static/media/sulawesi.e4e58790.jpg";